module.exports = __webpack_public_path__ + "static/media/candies1.0d5d4a9f.png";